import { TableauEmbed } from '@Components/TableauEmbed';
import { Spinner } from '@Components/Spinner/Spinner';
import { useTableauEmbedScript } from '@src/utils/hooks/tableau/useTableauEmbedScript';
import { useTableauToken } from '@src/utils/hooks/tableau/useTableauToken';
import { AMC_TABLEAU_DASHBOARD_URL } from './amc-tableau-constants';

export const AmcTableau = () => {
  const isScriptLoaded = useTableauEmbedScript();
  const { data: token } = useTableauToken();

  if (!isScriptLoaded || !token) return <Spinner />;

  return <TableauEmbed src={AMC_TABLEAU_DASHBOARD_URL} token={token} hideTabs />;
};
